import { render, staticRenderFns } from "./FileTransfers.vue?vue&type=template&id=045b949a&"
import script from "./FileTransfers.vue?vue&type=script&lang=js&"
export * from "./FileTransfers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports